import React from 'react';
import { motion } from 'framer-motion';

const ScrollIndicator = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="fixed right-8 top-1/2 transform -translate-y-1/2 z-40 hidden lg:flex flex-col space-y-3">
      {Array.from({ length: totalPages }, (_, index) => (
        <motion.button
          key={index}
          onClick={() => onPageChange(index)}
          className={`w-3 h-3 rounded-full transition-all duration-300 ${
            currentPage === index
              ? 'bg-gradient-to-r from-blue-500 to-purple-600 scale-125'
              : 'bg-white/30 hover:bg-white/50'
          }`}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 }}
        />
      ))}
      
      {/* Progress Line */}
      <div className="absolute left-1/2 top-0 w-0.5 h-full bg-white/20 transform -translate-x-1/2 -z-10">
        <motion.div
          className="w-full bg-gradient-to-b from-blue-500 to-purple-600"
          initial={{ height: '0%' }}
          animate={{ height: `${((currentPage + 1) / totalPages) * 100}%` }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        />
      </div>
    </div>
  );
};

export default ScrollIndicator;